// config.js
// 현재 환경이 production인지 development인지 확인
// process.env.NODE_ENV 값은 CRA(Create React App)나 Vite 같은 빌드 툴에서 자동으로 설정됩니다.
// 개발 서버(npm start) → "development"
// 운영 빌드(npm run build) → "production"
const isProduction = process.env.NODE_ENV === "production";

const API_BASE_URL = isProduction
  ? "https://submit.sejongiacf.com/api"   // 실서버용
  : "http://127.0.0.1:8696";       // 개발용

// 환경에 따라 다른 API 주소 선택
export default API_BASE_URL;